module.exports = __webpack_public_path__ + "7c23efed0bc31bb236021b2796995c0b.png";